import { memo, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ExternalLink } from '@doger/ui/components/ui/link';
import { SignInForm } from '@doger/core/modules/auth';
import { GoogleAuth } from '@doger/core/modules/auth';

import styles from './auth.module.scss';

const AuthPage = memo(() => {
  const navigate = useNavigate();
  const location = useLocation();

  const onSuccess = useCallback(() => {
    navigate(location.state?.from ?? '/');
  }, [location]);

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h1 className={styles.title}>Welcome to DOGER Admin</h1>
          </div>

          <GoogleAuth onSuccess={onSuccess} />

          <div className={styles.divider}>
            <div className={styles.dividerLine}> </div>
            <span className={styles.dividerText}>OR CONTUNUE WITH</span>
            <div className={styles.dividerLine}> </div>
          </div>

          <SignInForm className={styles.form} onSuccess={onSuccess} />

          <p className={styles.footerText}>
            By signing in, you agree to our{' '}
            <ExternalLink href='https://www.chat.layer2state.com/terms-of-service'>
              Terms of Service
            </ExternalLink>{' '}
            and{' '}
            <ExternalLink href='https://www.chat.layer2state.com/privacy-policy'>
              Privacy Policy
            </ExternalLink>
          </p>
        </div>
      </div>
    </div>
  );
});

export { AuthPage };
